/**
 * Android release artifacts (Help → About + in-app update).
 * Prefer Hosting URLs so Cuba / Google-blocked devices can still check updates.
 */

export const ANDROID_APK_STORAGE_PATH = 'releases/android/alea-tui-latest.apk';
export const ANDROID_VERSION_MANIFEST_PATH = 'releases/android/version.json';
export const ANDROID_APK_FILE_NAME = 'alea-tui.apk';
export const DEFAULT_ANDROID_HOSTING_ORIGIN = 'https://alea-tui.com';

export type AndroidApkConfig = {
  /** Direct HTTPS URL when set (e.g. Hosting or CDN). */
  url: string | null;
  storagePath: string;
  versionManifestPath: string;
  fileName: string;
  /** Public Hosting base for version.json + APK (no trailing slash). */
  hostingOrigin: string | null;
};

function hostingOriginFromEnv(env: Record<string, string | undefined>): string | null {
  const candidates = [
    String(env.VITE_ANDROID_UPDATE_ORIGIN ?? '').trim(),
    String(env.VITE_FUNCTIONS_ORIGIN ?? '').trim(),
    String(env.VITE_WEBAUTHN_ORIGIN ?? '').trim(),
    DEFAULT_ANDROID_HOSTING_ORIGIN,
  ];
  for (const value of candidates) {
    if (!value) continue;
    try {
      const url = new URL(value);
      if (url.protocol === 'https:') return `${url.origin}`;
    } catch {
      /* ignore */
    }
  }
  return null;
}

export function readAndroidApkConfig(
  env: Record<string, string | undefined> = {},
): AndroidApkConfig {
  const hostingOrigin = hostingOriginFromEnv(env);
  const explicitUrl = String(env.VITE_ANDROID_APK_URL ?? '').trim() || null;
  return {
    url: explicitUrl || (hostingOrigin
      ? `${hostingOrigin}/releases/android/alea-tui-latest.apk`
      : null),
    storagePath: ANDROID_APK_STORAGE_PATH,
    versionManifestPath: ANDROID_VERSION_MANIFEST_PATH,
    fileName: ANDROID_APK_FILE_NAME,
    hostingOrigin,
  };
}

/** Public Hosting URL for the version manifest (works when Google Storage is blocked). */
export function androidVersionManifestHostingUrl(config: AndroidApkConfig): string | null {
  if (!config.hostingOrigin) return null;
  return `${config.hostingOrigin}/releases/android/version.json`;
}
